import { AccountFeature } from "@models/account/feature";
import { createAction, props } from "@ngrx/store";

export default {
  featuresLoading: createAction("[Features] loading"),
  featuresLoaded: createAction("[Features] features loaded successfully", props<{ features: AccountFeature }>()),
  reset: createAction("[Features] reseted"),
  error: createAction("[Features] error", props<{ error: string }>())
};
